import {Inject, Injectable} from "@angular/core";
import {BaseApi} from "./baseService";
import {BaseResponse} from "../objects/common/baseResponse";
import {RequestOptions} from "@angular/http";
import {ExtraData} from "../objects/extraData/extraData";
import {ExtraDataSearchRequest, ExtraDataSearchType, ReferenceType} from "../objects/extraData/extraDataSearchRequest";


/**
 * Created by alex.y on 9/18/2017.
 */

@Injectable()
export class ExtraDataService extends BaseApi {
    public async getByRefIdandRefType(refId: string, refType: ReferenceType): Promise<BaseResponse<Array<ExtraData>>> {
        return this.search(new ExtraDataSearchRequest({
            SearchType: ExtraDataSearchType.ByRefIdAndRefType,
            ReferenceId: refId,
            ReferenceType: refType
        }));
    }

    public search(request: ExtraDataSearchRequest): Promise<BaseResponse<Array<ExtraData>>> {
        return this.post(new RequestOptions({
            url: `extradata/search`,
            body: request
        }));
    }

    public modify(extraData: ExtraData): Promise<BaseResponse<ExtraData>> {
        return this.put(new RequestOptions({
            url: `extradata`,
            body: extraData
        }));
    }
}


// WEBPACK FOOTER //
// ./app/services/extraDataService.ts